import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';
import TeamDialog from '../Teams/TeamDialog';

const CBRNE_VARIANT = {
  Chemical: 'red',
  Biological: 'amber',
  Radiological: 'green',
  Nuclear: 'blue',
  Explosion: 'neutral',
};

// Rendered inside a Card/CardHeader("Incident Navigation") by Dashboard.jsx.
// Mirrors the mockup's renderIncidentNavigation() row markup.
const AnnouncementsList = ({ announcements = [] }) => {
  const navigate = useNavigate();

  if (!announcements || announcements.length === 0) {
    return (
      <div className="px-5 py-10 text-center text-sm text-neutral-400">
        No incidents or drills logged yet.
      </div>
    );
  }

  return (
    <div>
      {announcements.map((item) => {
        const typeName = item.incident_type?.incident_type_name || (item.drill ? 'Drill' : 'Incident');
        return (
          <div
            key={item.id}
            className={`px-5 py-4 border-b border-neutral-50 hover:bg-neutral-50 transition-colors border-l-4 ${item.drill ? 'border-l-orange-400' : 'border-l-red-500'} group`}
          >
            <div className="flex justify-between items-start mb-1.5 gap-2">
              <Badge variant={CBRNE_VARIANT[typeName] || (item.drill ? 'amber' : 'red')}>{typeName}</Badge>
              {item.createdAt && (
                <span className="text-[10px] text-neutral-400 font-medium shrink-0">
                  {new Date(item.createdAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                </span>
              )}
            </div>
            <h4 className="text-sm font-bold text-neutral-900 group-hover:text-seha-700">{item.title}</h4>
            {item.location && (
              <p className="text-xs text-neutral-500 mt-1 flex items-center gap-1.5">
                <MapPin className="w-3 h-3 text-neutral-400 shrink-0" />
                <span className="truncate">{item.location}</span>
              </p>
            )}
            <div className="flex items-center gap-2 mt-3">
              <TeamDialog announcementId={item.id} />
              <Button variant="secondary" size="sm" onClick={() => navigate(`/active-incident/${item.id}`)}>
                Reject
              </Button>
              <Button variant="primary" size="sm" onClick={() => navigate(`/active-incident/${item.id}`)}>
                View
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AnnouncementsList;
